/* eslint-disable no-unused-expressions */
import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const BlogContentPage = () => {
  const { blogsContentApi } = apiPath;
  const [blogContent, blogContentLoading] = useFetch(blogsContentApi);
  if (blogContentLoading) {
    return <Loading />;
  }
  const { blogSectionBG, blogSectionTitle } = blogContent;

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "Text",
      name: "blogSectionBG",
      defaultValue: blogSectionBG,
      required: true,
    },
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "blogSectionTitle",
      defaultValue: blogSectionTitle,
      required: true,
    },
  ];
  const update = (data) => {
    updateData(blogsContentApi, data, true);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default BlogContentPage;
